import { render, staticRenderFns } from "./TaskCard.vue?vue&type=template&id=8875e2ec&scoped=true"
import script from "./TaskCard.vue?vue&type=script&lang=js"
export * from "./TaskCard.vue?vue&type=script&lang=js"
import style0 from "./TaskCard.vue?vue&type=style&index=0&id=8875e2ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8875e2ec",
  null
  
)

export default component.exports